module.exports = __webpack_public_path__ + "static/case-studies-9fe1484ebd0dfd567aab3757f34a4571.jpg";